import useLenis from "@/hooks/useLenis";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Consultants from "@/components/Consultants";
import Services from "@/components/Services";
import Timings from "@/components/Timings";
import Booking from "@/components/Booking";
import Footer from "@/components/Footer";

export default function Home() {
  useLenis();
  return (
    <div className="bg-[var(--bg)]">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Consultants />
        <Services />
        <Timings />
        <Booking />
      </main>
      <Footer />
    </div>
  );
}
